import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { CssBaseline } from "@material-ui/core";

import Navbar from "./Components/navbar/Navbar";
import Home from "./pages/home/Home";
import Dashboard from "./pages/dashboard/Dashboard";
import Videos from "./pages/videos/Videos";
import Chat from "./pages/chat/Chat";
import Info from "./pages/info/Info";
import PrivateRoute from "./PrivateRoute";

import Signup from "./pages/account/Signup";
import Login from "./pages/account/Login";
import ForgotPassword from "./pages/account/ForgotPassword";

function App() {
  return (
    <div className="app">
      <CssBaseline />
      <Router>
        <header>
          <Navbar />
        </header>
        <main className="sections">
          {/* Main Components */}
          <Switch>
            <Route path="/" component={Home} exact />
            <PrivateRoute path="/dashboard" component={Dashboard} exact />
            <Route path="/videos" component={Videos} exact />
            <PrivateRoute path="/chat" component={Chat} exact />
            <PrivateRoute path="/univinfo/:univname" component={Info} />
            <Route path="/signup" component={Signup} exact />
            <Route path="/login" component={Login} exact />
            <Route path="/forgot-password" component={ForgotPassword} exact />
            <Redirect to="/" />
          </Switch>
        </main>
      </Router>
    </div>
  );
}

export default App;
